import { computed } from 'vue';

import { usePlatformStore } from './store/platform';
import { useUserStore } from '@/store/user';
import { useProjectStore } from '@/store/project';
import { useIntegrationsStore } from '@/store/integrations';
import { useOrganisationStore } from '@/store/organisation';
import { useInstallations } from '@/services/integrations';

export const useLoadingState = () => {
  const platformStore = usePlatformStore();
  const userStore = useUserStore();
  const projectStore = useProjectStore();
  const integrationStore = useIntegrationsStore();
  const organisationStore = useOrganisationStore();
  const { installations } = useInstallations();

  const states = computed(() => [
    {
      name: 'Platform',
      ready: platformStore.ready,
      value: platformStore.platform?.name,
    },
    {
      name: 'User',
      ready: userStore.ready,
      value: userStore.user?.email,
      redirect: userStore.redirect,
      updateRedirect: userStore.updateRedirect,
    },
    {
      name: 'Project',
      ready: projectStore.ready,
      value: projectStore.active?.name,
      redirect: projectStore.redirect,
      updateRedirect: userStore.updateRedirect,
    },
    {
      name: 'Integrations',
      ready: integrationStore.ready,
      value:
        installations.value.length > 0
          ? installations.value.map((i) => i.integration.code).join(', ')
          : undefined,
      redirect: integrationStore.redirect,
      updateRedirect: userStore.updateRedirect,
    },
    {
      name: 'Organisation',
      ready: organisationStore.ready,
      value: organisationStore.active?.name,
      redirect: organisationStore.redirect,
      updateRedirect: userStore.updateRedirect,
    },
  ]);

  return {
    states,
    stateWithRedirect: computed(() => states.value.find((s) => s.redirect)),
    loaded: computed(() => states.value.every((s) => s.ready)),
  };
};
